<template>
	<div class="photoCard">
		<div class="photo" :style="bgImage"></div>
		<div class="cardHeader">
			<span class="profile" style="background-image: url(/static/img/placeholder.png);"></span>
			<h3>{{ cardData.json_object.title }} <small>{{ whenDate }}</small></h3>
		</div>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
      name: 'photo-card',
      props: {
        cardData: {
          type: Object,
          default: null
        }
      },
      computed: {
        bgImage () {
          return 'background-image: url(' + this.cardData.json_object.url_m + ');'
        },
        whenDate () {
          return moment(this.cardData.created_at).fromNow()
        }
      },
      mounted: function () {
        // console.log('Photo of the Day')
        // console.log(this.cardData)
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cards/Photo.vue